export default __webpack_public_path__ + "static/media/RETAIL.31ad4ccc.png";